<template>
  <v-sheet class="my-3">
    <!-- <v-card-subtitle class="text-h6 py-1">预算明细</v-card-subtitle> -->
    <v-divider></v-divider>
    <v-table-searchable
      ref="table"
      :show-select="false"
      :table-name="tableName"
      :headers="headers"
      :req-url="reqUrl"
      :fix-header="false"
      :search-remain="searchObj"
    >
      <template #searchflieds>
        <v-col cols="12" sm="6" md="2">
          <v-autocomplete
            v-model="searchObj.applyType"
            :items="[
              // { text: '准入申请', value: 1 },
              // { text: '应急转临时供应商', value: 2 },
              // { text: '临时转合格供应商', value: 3 },
              // { text: '市场业务转合格供应商', value: 4 },
              { text: '慎用', value: 5 },
              { text: '退出', value: 6 },
              { text: '警告', value: 7 },
              { text: '奖励', value: 8 },
              // { text: '修改准入信息', value: 9 },
            ]"
            label="申请类型"
            outlined
            clearable
            dense
          ></v-autocomplete>
        </v-col>
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <v-chip small :color="statusColors[item.status]" :dark="true">
          {{ statuses2[item.status] }}
        </v-chip>
      </template>
      <template v-slot:[`item.applicationNo`]="{ item }">
        <router-link
          v-if="
            item.applyType == 1 ||
            item.applyType == 2 ||
            item.applyType == 3 ||
            item.applyType == 4
          "
          :to="{
            name: 'registerSupplier-detail',
            params: { id: item.id },
          }"
        >
          {{ item.applicationNo }}
        </router-link>
        <router-link
          v-if="
            item.applyType == 5 ||
            item.applyType == 6 ||
            item.applyType == 7 ||
            item.applyType == 8
          "
          :to="{
            name: 'supplier-warning-reward-detail',
            params: { id: item.id },
          }"
        >
          {{ item.applicationNo }}
        </router-link>
        <router-link
          v-if="item.applyType == 9"
          :to="{
            name: 'supplier-change-detail',
            params: { id: item.id },
          }"
        >
          {{ item.applicationNo }}
        </router-link>
        <!-- <div v-else>--</div> -->
      </template>
      <template v-slot:[`item.applyType`]="{ item }">
        <v-chip small v-if="item.applyType == 1">准入申请</v-chip>
        <v-chip small v-if="item.applyType == 2">应急转临时供应商</v-chip>
        <v-chip small v-if="item.applyType == 3">临时转合格供应商</v-chip>
        <v-chip small v-if="item.applyType == 4">市场业务转合格供应商</v-chip>
        <v-chip small v-if="item.applyType == 5" color="warning">慎用</v-chip>
        <v-chip small v-if="item.applyType == 6" color="error">退出</v-chip>
        <v-chip small v-if="item.applyType == 7" color="warning">警告</v-chip>
        <v-chip small v-if="item.applyType == 8">奖励</v-chip>
        <v-chip small v-if="item.applyType == 9">变更准入信息</v-chip>
      </template>
    </v-table-searchable>
    <v-divider></v-divider>
  </v-sheet>
</template>
<script>
export default {
  name: 'supplier-in-data-list',
  created() {
    this.tableName = '供应商警告奖励慎用退出记录'
    this.reqUrl = '/business/shipAffairs/supplierInOut/list'
    this.headers = [
      { text: '申请单号', value: 'applicationNo' },
      { text: '申请类型', value: 'applyType' },
      { text: '申请日期', value: 'applyDate' },
      { text: '供应商名称', value: 'supplierName' },
      { text: '审批状态', value: 'status' },
      { text: '业务状态', value: 'businessStatus' },
    ]
    this.statuses = ['', '草稿', '审批中', '通过']
    this.color = ['', '草稿', '审批中', '通过']
    this.statuses2 = ['暂无审批', '草稿', '审批中', '已审批', '已驳回', '废弃']
    this.statusColors = ['info', '', 'warning', 'success', 'error', 'error']
    this.statusMap = [
      { text: '草稿', value: '1' },
      { text: '审批中', value: '2' },
      { text: '已审批', value: '3' },
      { text: '已驳回', value: '4' },
      { text: '废弃', value: '5' },
    ]
  },
  props: {
    supplierId: String,
  },
  data() {
    return {
      list: [],
      searchObj: {
        supplierId: this.supplierId,
        applyType: [5, 6, 7, 8],
        status: '3',
      },
    }
  },

  methods: {},

  mounted() {},
}
</script>

<style></style>
